import { Pageable } from "./pageable";

export class Pageable2{
    pageable: Pageable;
    sort: Sort;
    filter: Filter;
}

export class Sort {
    column: string;
    direction: string;
}

export class Filter {
    columns: string[];
    value: string;
}